export default __webpack_public_path__ + "static/media/battery_power.5080a164.svg";